export const parseServerTiming = (serverTiming: string) => {
  const rows = serverTiming
    .split(', ')
    .map(x => x.split(';').filter(Boolean))
    .map(x => {
      if (x.length < 3) return null;
      const metric = x[0];
      const metricParts = metric.split('-');
      const type = metricParts.shift();
      const id = metricParts.join('-');
      const description = decodeURIComponent(x[1].split('=')[1]);
      const timeTaken = Number(x[2].split('=')[1]);
      return { type, id, description, timeTaken };
    })
    .filter(Boolean);

  return {
    rows: rows,
    totalTimeTaken: rows.reduce((acc, x) => acc + x.timeTaken, 0),
  };
};
